<script>
export default {
  name: 'MenuCard',
  props: {
    name: {
      type: String,
      required: true,
    },
    price: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: '',
    },
  },
  computed: {},
  methods: {
    // onClick() {
    //   this.$emit('click', this.menu)
    // },
    nl2br(text) {
      return text.replace(/\n/g, '<br />')
    },
  },
}
</script>

<template>
  <v-card
    flat
    color="fufugrey2"
    class="fill-height white--text"
    v-on="$listeners"
  >
    <v-layout
      column
      class="pa-2 text-1 "
      fill-height
      justify-center
      align-center
    >
      <span class="font-weight-bold fufuyellow--text text-h6">{{ name }}</span>
      <span v-if="price" class="font-weight-bold"
        >{{ price.toLocaleString() }}円</span
      >
      <small class="text-center pt-2" v-html="nl2br(description)" />
    </v-layout>
  </v-card>
</template>
